export default __webpack_public_path__ + "static/media/Home.99a54a45.svg";